import { AbsenceIcon, EmployeeAvatarDto } from "./organization/company";

export enum DashboardCalendarEventType {
  BIRTHDAY = "BIRTHDAY",
  NEW_JOINER = "NEW_JOINER",
  LEAVER = "LEAVER",
  ANNIVERSARY = "ANNIVERSARY",
  ABSENCE_STARTING = "ABSENCE_STARTING",
  ABSENCE_ENDING = "ABSENCE_ENDING",
  DOCUMENT_EXPIRES = "DOCUMENT_EXPIRES",
  RETURN_INVENTORY = "RETURN_INVENTORY",
}

export type DashboardCalendarEvent = {
  absenceRequestDuration: number | null;
  absenceRequestEndDate: string | null;
  absenceRequestIcon: AbsenceIcon | null;
  absenceRequestStartDate: string | null;
  absenceRequestType: string | null;
  anniversaryYears: number | null;
  date: string;
  employeeAvatarDto: EmployeeAvatarDto;
  event: DashboardCalendarEventType;
};
